<h1 mat-dialog-title> Editar Usuario </h1> <br/>
 
 
<form #usuarioForm = ngForm>

    <mat-dialog-content>
        
        <p> <mat-label> <h2> Datos Usuario </h2> </mat-label> </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Nombres </mat-label>
                
                <input name = "nombres" matInput [(ngModel)] = "usuario.nombres" #nombres = "ngModel" required autofocus />

            </mat-form-field>
        </p>
        
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Apellido Paterno </mat-label>
                
                <input name = "apellidoPaterno" matInput [(ngModel)] = "usuario.apellidoPaterno" required 
                #apellidoPaterno = "ngModel" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Apellido Materno </mat-label>
                
                <input name = "apellidoMaterno" matInput [(ngModel)] = "usuario.apellidoMaterno" 
                #apellidoMaterno = "ngModel" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> RUT </mat-label>
                
                <input name = "rut" matInput [(ngModel)] = "usuario.rut" required placeholder = "Formato: 11111111-1"
                pattern = "[0-9.]{7,10}[-]{1}[0-9Kk]{1}" #rut = "ngModel" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Correo </mat-label>
                
                <input name = "correo" matInput type = "email" [(ngModel)] = "usuario.correo" required 
                #correo = "ngModel"/>

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Tipo Afiliado </mat-label>
                
                <mat-select name = "tipoAfiliado" #tipoAfiliado = "ngModel" [(ngModel)] = "usuario.tipoAfiliado" required>

                    <mat-option *ngFor = "let tipo of data.tipoAfiliado" value = "{{tipo}}">
                        
                        {{tipo}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fecha Ingreso </mat-label>
                
                <input name = "fechaIngreso" matInput type = "date" 
                [(ngModel)] = "usuario.fechaIngreso" #fechaIngreso = "ngModel"> 
                
            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fecha Nacimiento </mat-label>
                
                <input name = "fechaNacimiento" matInput type = "date" 
                [(ngModel)] = "usuario.fechaNacimiento" required #fechaNacimiento = "ngModel"> 
                
            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fono Fijo </mat-label>
                
                <input name = "fonoFijo" matInput placeholder = "11111111"
                [(ngModel)] = "usuario.fonoFijo" pattern = "[0-9]{8}"/>

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fono Movil </mat-label>
                
                <input name = "fonoMovil" matInput placeholder = "11111111" 
                [(ngModel)] = "usuario.fonoMovil" pattern = "[0-9]{8}"/>

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Sexo</mat-label>

                <mat-select name = "sexo" #sexo = "ngModel" [(ngModel)] = "usuario.sexo" required>
                    
                    <mat-option *ngFor = "let sexo of data.sexos" [value] = "sexo.id">             
                        
                        {{sexo.descripcion}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>
      
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Estado Civil </mat-label>
                
                <mat-select name = "estadoCivil" #estadoCivil = "ngModel" 
                [(ngModel)] = "usuario.estadoCivil" required>

                    <mat-option *ngFor = "let estado of data.estadoCivil" [value] = "estado.id">
                        
                        {{estado.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Sistema de salud </mat-label>
                
                <mat-select name = "sistemaSalud" #sistemaSalud = "ngModel" 
                [(ngModel)] = "usuario.sistemaSalud" required>

                    <mat-option *ngFor = "let estado of data.sistemaSalud" [value] = "estado.id">
                        
                        {{estado.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p> <mat-label> <h2> Datos Direccion </h2> </mat-label> </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Descripcion </mat-label>
                
                <input name = "descripcionDir" #descripcionDir = "ngModel" matInput 
                [(ngModel)] = "usuario.direccion.descripcion" required />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Descripcion Adicional </mat-label>
                
                <input name = "descripcionDirAd" #descripcionDirAd = "ngModel" matInput 
                [(ngModel)] = "usuario.direccion.descripcionAdicional" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Número </mat-label>
                
                <input name = "numero" #numero = "ngModel" matInput pattern = "[0-9]{1,}"
                [(ngModel)] = "usuario.direccion.numero" required placeholder = "Solo números"/>

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Región </mat-label>
                
                <mat-select name = "region" #region = "ngModel" [(ngModel)] = "usuario.direccion.region" 
                (selectionChange) = "traeComunas()" required>

                    <mat-option *ngFor = "let region of data.regiones" [value] = "region.id">
                        
                        {{region.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Comuna </mat-label>
                
                <mat-select name = "comuna" #comuna = "ngModel" [(ngModel)] = "usuario.direccion.comuna" required>

                    <mat-option *ngFor = "let comuna of data.comunas" [value] = "comuna.id">
                        
                        {{comuna.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p> <mat-label> <h2> Datos Laborales </h2> </mat-label> </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Tipo Unidad </mat-label>
                
                <input name = "tipoUnidad" matInput [(ngModel)] = "usuario.datosLaborales.tipoUnidad" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Unidad </mat-label>
                
                <input name = "unidad" matInput [(ngModel)] = "usuario.datosLaborales.unidad" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Calidad Jurídica </mat-label>
                
                <input name = "calidadJuridica" matInput [(ngModel)] = "usuario.datosLaborales.calidadJuridica" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Estamento </mat-label>
                
                <input name = "estamento" matInput [(ngModel)] = "usuario.datosLaborales.estamento" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Descripcion (Dirección) </mat-label>
                
                <input name = "descripcionDirDat" #descripcionDirDat = "ngModel" matInput 
                [(ngModel)] = "usuario.datosLaborales.direccion.descripcion" required />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Descripcion Adicional (Dirección) </mat-label>
                
                <input name = "descripcionDirAdDat" #descripcionDirAdDat = "ngModel" matInput 
                [(ngModel)] = "usuario.datosLaborales.direccion.descripcionAdicional" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Número (Dirección) </mat-label>
                
                <input name = "numeroDirDat" #numeroDirDat = "ngModel" matInput pattern = "[0-9]{1,}"
                [(ngModel)] = "usuario.datosLaborales.direccion.numero" required placeholder = "Solo números"/>

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Región (Dirección) </mat-label>
                
                <mat-select name = "regionDirDat" #regionDirDat = "ngModel" (selectionChange) = "traeComunasDirDat()"
                [(ngModel)] = "usuario.datosLaborales.direccion.region"  required>

                    <mat-option *ngFor = "let region of data.regionesDirDat" [value] = "region.id">
                        
                        {{region.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Comuna (Dirección) </mat-label>
                
                <mat-select name = "comunaDirDat" #comunaDirDat = "ngModel" required
                [(ngModel)] = "usuario.datosLaborales.direccion.comuna">

                    <mat-option *ngFor = "let comuna of data.comunasDirDat" [value] = "comuna.id">
                        
                        {{comuna.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p> <mat-label> <h2> Permiso </h2> </mat-label> </p>

        <p>
            <mat-form-field appearance="outline" class = "mat-input">
                <mat-label>Rol</mat-label>
                <mat-select  name = "rol"   #rol = "ngModel" [(ngModel)] = "data.rolSeleccionado"   multiple [disabled]="this.data.rolUsuario !== 'ROLE_ADMINISTRADOR'" >
                    <mat-option *ngFor="let rol of data.roles" [value]="rol.id"> {{rol.descripcion}} </mat-option>
                </mat-select>
            </mat-form-field>
        </p>

    </mat-dialog-content> <br/> 

    <mat-dialog-actions>
        <div  *ngIf = "this.data.rolUsuario =='ROLE_ADMINISTRADOR' || this.data.rolUsuario =='ROLE_ENCARGADO_CONTABILIDAD'">  
            <button mat-button class = "mat-raised-button btn-success" (click) = "editarUsuario()" [disabled] = "usuarioForm.invalid"> 
                <i class = "fa fa-plus"> </i> Guardar
            </button>
        </div>
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()"> 
            <i class = "fa fa-trash"> </i> Salir
        </button>
        
    </mat-dialog-actions>
 
</form>
